export const GET_TRANSACTION = 'PC/get_transaction';
export const SHOW_TRANSACTION = 'PC/show_transaction';
export const TAG_AS_PRINTED = 'PC/tag_as_printed';
export const TAG_AS_RECIVED = 'PC/tag_as_received';
export const START_ASSESSMENT = 'PC/start_assessment';
export const GENERATE_POLICE_CLEARANCE = 'api/v1/administrators/transaction_histories/police_clearance/';